import React, { useEffect, useState } from "react"
import { Link, NavLink } from "react-router-dom"
import { SiShopware } from "react-icons/si"
import { MdOutlineCancel } from "react-icons/md"
import { TooltipComponent } from "@syncfusion/ej2-react-popups"

import { useStateContext } from "../contexts/ContextProvider"
import {
  adminLinks,
  managerLinks,
  shopManagerLinks,
} from "../config/routeConfig"

const Sidebar = () => {
  const { currentColor, activeMenu, setActiveMenu, screenSize } =
    useStateContext()

  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 1600) {
      setActiveMenu(false)
    }
  }

  const [links, setlinks] = useState([])
  const data = localStorage.getItem("user")
  const userData = data ? JSON.parse(data) : null
  const { role, empId } = userData?.profile

  useEffect(() => {
    if (role === "admin") {
      setlinks(adminLinks)
    } else if (role === "manager" && empId === "2026_BOOST_5895") {
      setlinks(shopManagerLinks)
    } else {
      setlinks(managerLinks)
    }
  }, [data])

  const activeLink =
    "flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg  text-white  text-md m-2"
  const normalLink =
    "flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-md text-gray-700 dark:text-gray-200 dark:hover:text-black hover:bg-light-gray m-2"

  // console.log("links",links);
  return (
    <div className="ml-3 h-screen md:overflow-hidden overflow-auto md:hover:overflow-auto pb-10">
      {activeMenu && (
        <>
          <div className="flex justify-between items-center">
            <Link
              to="/overview"
              onClick={handleCloseSideBar}
              className="items-center gap-3 ml-3 mt-4 flex text-xl font-extrabold tracking-tight dark:text-white text-slate-900"
            >
              {/* <SiShopware /> <span>Shoppy</span> */}
              <img
                src="https://boostmobiledetailing.ca/wp-content/uploads/2024/01/boost-detailing-logo.png"
                alt=""
                className="w-20"
              />
            </Link>
            <TooltipComponent content="Menu" position="BottomCenter">
              <button
                type="button"
                onClick={() => setActiveMenu(!activeMenu)}
                style={{ color: currentColor }}
                className="text-xl rounded-full p-3 hover:bg-light-gray mt-4 block md:hidden"
              >
                <MdOutlineCancel />
              </button>
            </TooltipComponent>
          </div>
          <div className="mt-10 ">
            {links.map((item) => (
              <div key={item.title}>
                <p className="text-gray-400 dark:text-gray-400 m-3 mt-4 uppercase">
                  {item.title}
                </p>
                {item.links.map((link) => (
                  <NavLink
                    to={`/${link.name}`}
                    key={link.name}
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    {link.icon}
                    <span className="capitalize ">{link.name}</span>
                  </NavLink>
                ))}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  )
}

export default Sidebar
